class ProductShare extends HTMLElement {
  constructor() {
    super();

    this.copyButton = this.querySelector('[data-share-copy]');
    this.copyLabel = this.querySelector('[data-copy-label]');
    this.popupLinks = this.querySelectorAll('[data-share-popup]');
  }

  connectedCallback() {
    if (this.copyButton) {
      this.copyButton.addEventListener('click', this.onCopy.bind(this));
    }

    this.popupLinks.forEach(link => {
      link.addEventListener('click', this.onPopupOpen.bind(this));
    });
  }

  get shareUrl() {
    return this.copyButton ? this.copyButton.dataset.shareUrl : window.location.href;
  }

  async onCopy() {
    const original = this.copyLabel ? this.copyLabel.textContent : '';
    try {
      await navigator.clipboard.writeText(this.shareUrl);
      if (this.copyLabel) {
        this.copyLabel.textContent = 'Copied!';
        setTimeout(() => { this.copyLabel.textContent = original; }, 1500);
      }
    } catch (e) {
      window.prompt('Copy this link:', this.shareUrl);
    }
  }

  onPopupOpen(event) {
    const href = event.currentTarget.href;
    const width = 575;
    const height = 400;
    const left = (window.outerWidth - width) / 2 + (window.screenX || 0);
    const top = (window.outerHeight - height) / 2 + (window.screenY || 0);
    const opts = `status=1,width=${width},height=${height},top=${top},left=${left}`;

    const popup = window.open(href, 'share', opts);
    if (popup) {
      event.preventDefault();
    }
    // Blocked? Let target="_blank" handle it.
  }
}

if (!customElements.get('product-share')) {
  customElements.define('product-share', ProductShare);
}
